import Image from '@atoms/Image/Image';
import LinkCard from '@atoms/LinkCard/LinkCard';
import { IKitBag } from '@models/IKitBag';

interface Props {
  item: IKitBag['items'][number];
  index: number;
  focusedIndex: number;
  focusPlaceholderRef: React.RefObject<HTMLAnchorElement>;
  wrapWithContainer?: boolean;
  desktopWrapperClassName?: string;
}

const KitBagCard = ({
  item,
  index,
  focusedIndex,
  focusPlaceholderRef,
  wrapWithContainer = false,
  desktopWrapperClassName,
}: Props) => {
  return (
    <div
      key={item.name}
      // eslint-disable-next-line react/no-unknown-property
      track-product-impression="true"
      data-product={JSON.stringify(item.trackingData ?? '')}
      className={wrapWithContainer ? desktopWrapperClassName : ''}
    >
      <LinkCard
        link={item.link}
        ref={
          focusedIndex > 0 && focusedIndex === index
            ? focusPlaceholderRef
            : null
        }
      >
        <div className="flex h-full flex-row items-center gap-5 overflow-hidden overflow-x-hidden px-5 py-4 xl:gap-8 xl:px-8 2xl:gap-11 2xl:pl-11">
          {item.thumbnail && (
            <div className="flex h-full w-[70px] shrink-0 justify-center md:w-[120px]">
              <Image
                image={item.thumbnail}
                imageClasses="h-full object-contain"
                sizes="300px"
              />
            </div>
          )}
          <div className="body-one flex flex-col">
            {item.name && (
              <span className="font-normal text-black-100 dark:font-light dark:text-yellow">
                {item.name}
              </span>
            )}
            {item.description && <span>{item.description}</span>}
          </div>
        </div>
      </LinkCard>
    </div>
  );
};

export default KitBagCard;
